<template>
  <div>
    <v-img
      class="d-flex justify-center"
      src="/WebsiteBanner.jpg"
      height="100vh"
    >
      <v-container pa-8>
        <v-row><v-spacer></v-spacer></v-row>
        <v-row align="center" style="height: 100vh">
          <v-spacer></v-spacer>
          <v-col align="center">
            <div class="text-center">
              <v-btn
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    color="grey darken-3"
                    style="opacity: 0.75"
                    href= 'https://open.spotify.com/artist/4yqp9NiO7zJLy1eHzb54Ro'
                    target="blank"
                    >Listen Now
                </v-btn>
              <!-- <v-bottom-sheet v-model="sheet">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    color="grey darken-3"
                    style="opacity: 0.75"
                    >Listen Now
                  </v-btn>
                </template>
                <v-list>
                  <v-subheader>Listen on</v-subheader>
                  <v-list-item
                    v-for="tile in tiles"
                    :key="tile.title"
                    @click="sheet = false"
                    :href="tile.url"
                    target="blank"
                  >
                    <v-list-item-avatar>
                      <v-icon :color="tile.color" size="24px">
                        mdi-{{ tile.img }}
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title>{{ tile.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-bottom-sheet> -->
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row><v-spacer></v-spacer></v-row>
      </v-container>
    </v-img>

    <v-container id="music" class="mt-8 text-center" width="100%">
      <v-layout row wrap justify-center>
        <v-btn
          v-for="social in socials"
          :key="social.img"
          class="mx-3"
          icon
          :href="social.link"
          target="blank"
        >
          <v-icon size="24px">
            {{ social.img }}
          </v-icon>
        </v-btn>
      </v-layout>
    </v-container>
    
    <!--Grid system uses Container, Layouts (use row prop) and Flex's -->
    <v-container class="my-5 mt-0">
      <v-layout row wrap justify-center>
        <!--v-layout is a row-->
        <v-flex
          v-for="(song, songIndex) in soundcloudSongs.slice().reverse()"
          :key="song.title"
          xs10
          sm8
          md6
          lg5
          class="pa-5"
        >
          <v-hover v-slot:default="{ hover }">
            <!--v-flex is an item in the row-->
            <v-card :elevation="hover ? 12 : 2">
              <v-card v-if="songIndex == 0" justify-center height="50">
                <v-card-title style="font-size:1em" class="justify-center">
                  New Release
                </v-card-title>
              </v-card>
              <v-card v-else height="50">
                <v-card-title></v-card-title>
              </v-card>
              <v-img contain :src="song.image.split(',')[0]"></v-img>
              <!-- <v-card-title>{{ song.name }}</v-card-title>
              <v-card-subtitle>{{ song.name }}</v-card-subtitle> -->
              <iframe
                style="display: block"
                width="100%"
                height="80"
                scrolling="no"
                frameborder="no"
                allow="autoplay"
                :src="song.url.substring(0, 25) + 'embed/' + song.url.substring(25)"
              ></iframe>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="song.showText = !song.showText">
                  <v-icon>{{
                    song.showText ? "mdi-chevron-up" : "mdi-chevron-down"
                  }}</v-icon>
                </v-btn>
              </v-card-actions> -->
              <!-- <v-expand-transition>
                <div v-show="song.showText">
                  <v-divider></v-divider>
                  <v-card-text>{{ song.text }}</v-card-text>
                </div>
              </v-expand-transition> -->
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid id="videos">
      <v-layout row justify-center>
        <v-flex xs10 class="pa-5">
          <v-carousel height="40vw">
            <v-carousel-item v-for="video in youtubeVideos" :key="video.url">
              <v-sheet height="100%" tile>
                <v-row class="fill-height" align="center" justify="center">
                    <iframe
                      width="100%"
                      height="100%"
                      :src="video.url + '?controls=0'"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope;"
                      allowfullscreen
                    ></iframe>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container>
        <v-row><v-spacer></v-spacer></v-row>
        <v-row align="center" style="height: 10vh">
          <v-spacer></v-spacer>
          <v-col align="center">
            <p>
              Join the Lockbox community discord!
            </p>
            <div class="text-center">
              <v-btn
                    large
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    color="grey darken-3"
                    style="opacity: 0.75"
                    :href= 'socials[3].link'
                    target="blank"
                    >
                    <v-icon dark large>
                      mdi-discord
                    </v-icon>
                    JOIN NOW
                </v-btn>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row><v-spacer></v-spacer></v-row>
      </v-container>

    <v-container id="about">
      <v-row dense>
        <v-col cols="12">
          <div class="d-flex flex-no-wrap align-center justify-space-between">
            <v-avatar class="ma-3" size="125">
              <v-img src="overgrown_lockbox_icon.jpg"></v-img>
            </v-avatar>
            <div>
              <v-card-title class="headline">About Lockbox</v-card-title>
              <v-card-subtitle
                >Based out of LA and an Icon Collective alumni, Lockbox wishes
                to push the boundaries of what music can achieve, and more
                importantly, where music can take you.</v-card-subtitle
              >
            </div>
          </div>
          <div class="mx-3 pb-1">
            <p>
              Playing the piano and violin since the age of 12, Lockbox is
              determined to bring feeling, emotional narrative, and a fresh
              perspective into modern day Electronic Dance Music. Through his
              timeless melodies, detailed orchestration, euphoric drops, lush
              atmospheres, and beautiful vocal storylines, Lockbox formulates an
              immersive audio visual experience that blends the line between
              fantasy and reality.
            </p>
            <p>
              Lockbox represents a virtual space where he can be himself and
              pour all his heart into. For him, music offers an emotional
              escape, and he wishes that through his music, it can be a
              beautiful refuge for the listener as well. Each song and virtual
              world inside Lockbox is a manifestation of who he is and what he
              feels - a part of him. All are welcome here, we hope you enjoy
              your stay.
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import db from '@/fb'

export default {
  name: "HelloWorld",

  data: () => ({
    sheet: false,

    socials: [
      {
        img: "mdi-spotify",
        link:
          "https://open.spotify.com/artist/4yqp9NiO7zJLy1eHzb54Ro?si=rsCRLAPxQVuRfGZPPtX4YQ",
      },
      { img: "mdi-soundcloud", link: "https://soundcloud.com/lockboxmusic" },
      { img: "mdi-instagram", link: "https://www.instagram.com/lockboxmusic/" },
      { img: "mdi-discord", link: "https://discord.com/invite/qje5EU3" },
      { img: "mdi-twitter", link: "https://twitter.com/Lockboxmusic" },
    ],

    tiles: [
      {
        img: "spotify",
        color: "green",
        title: "Spotify",
        url: "https://open.spotify.com/artist/4yqp9NiO7zJLy1eHzb54Ro",
      },
      {
        img: "soundcloud",
        color: "orange",
        title: "Soundcloud",
        url: "https://soundcloud.com/lockboxmusic",
      },
      {
        img: "youtube",
        color: "red",
        title: "Youtube",
        url: "https://www.youtube.com/channel/UCIzFV40lw_3gVFL4MbNw1GQ",
      },
    ],

    fab: false,
    youtubeVideos: [],
    soundcloudSongs: [],
  }),
  created() {
    db.collection('Youtube').onSnapshot(res => {
      const changes = res.docChanges();

      changes.forEach(change => {
        if (change.type === 'added') {
          this.youtubeVideos.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    }),
    db.collection('Spotify').onSnapshot(res => {
      const changes = res.docChanges();

      changes.forEach(change => {
        if (change.type === 'added') {
          this.soundcloudSongs.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }
      })
    })
  }
};
  
</script>
